import { gql } from '@apollo/client';

export const UPDATE_DOCUMENT_SIGN_STATE_TRANSITION = gql`
  mutation addOrUpdateDocumentSignStateTransition($input: DocumentSignStateTransitionInput!) {
    addOrUpdateDocumentSignStateTransition(input: $input) {
      commandId
    }
  }
`;

export const DELETE_DOCUMENT_SIGN_STATE_TRANSITION = gql`
  mutation deleteDocumentSignStateTransition($input: DocumentSignStateTransitionInput!) {
    deleteDocumentSignStateTransition(input: $input) {
      commandId
    }
  }
`;
